import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';

import { DataTableModule } from 'angular-4-data-table-bootstrap-4';
import { BeasleyService } from '../../services/beasley/beasley.service';

import { SharedModule } from '../../shared.module';
import { BeasleyComponent } from './beasley.component';
import { BfpHeaderComponent } from './bfp-header/bfp-header.component';
import { BfpClaimsComponent } from './bfp-claims/bfp-claims.component';
import { FieldComponent } from '../field/field.component';

const BeasleyRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'beasley/claims',
    component: BfpClaimsComponent,
  }, 
]);

@NgModule({
  exports: [
  ],
  imports: [
    NgbDropdownModule.forRoot(),
    BeasleyRouting, 
    SharedModule,
    DataTableModule,
    NgxMaskModule.forRoot(),
  ],
  declarations: [
    BeasleyComponent,
    BfpHeaderComponent,
    BfpClaimsComponent,
    // FieldComponent
  ],
  providers: [
    BeasleyService,
    NgbModal,
    NgbActiveModal,
  ],
  // add components here for dynamic loading
  entryComponents: [ 
    // FieldComponent
  ]
})

export class BeasleyModule {}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/beasley/beasley.module.ts